import axios from 'axios';
import { seedNavPresetCache, seedFooterPresetCache } from '@/hooks/usePresets';
import { seedHomepagePageConfig } from '@/hooks/usePageConfig';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let bootstrapData = null;
let bootstrapPromise = null;

export function isHomepagePath(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  return pathname === '/' || pathname === '';
}

export function getPublicHomeBootstrap() {
  return bootstrapData;
}

export function getHomepageBootstrapPromise() {
  if (bootstrapData) return Promise.resolve(bootstrapData);
  return bootstrapPromise;
}

function seedPresetCaches(data) {
  if (!data) return;
  const pageType = data.page_config?.page_type || 'marketing';
  const navOverride = data.page_config?.nav_preset_override_id || null;
  const footerOverride = data.page_config?.footer_preset_override_id || null;

  seedNavPresetCache(pageType, navOverride, data.nav_preset || null);
  seedFooterPresetCache(pageType, footerOverride, data.footer_preset || null);

  // PublicLayout renders before page meta is broadcast — seed the default key too.
  if (navOverride) {
    seedNavPresetCache(pageType, null, data.nav_preset || null);
  }
  if (footerOverride) {
    seedFooterPresetCache(pageType, null, data.footer_preset || null);
  }
  // Initial chrome uses marketing until page meta arrives.
  if (pageType !== 'marketing') {
    seedNavPresetCache('marketing', null, data.nav_preset || null);
    seedFooterPresetCache('marketing', null, data.footer_preset || null);
  }
}

export function applyHomepageBootstrap(data) {
  if (!data) return;
  bootstrapData = data;
  if (data.page_config) {
    seedHomepagePageConfig(data.page_config);
  }
  seedPresetCaches(data);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('public-home-bootstrap-ready'));
  }
}

export function prefetchHomepageBootstrap() {
  if (typeof window === 'undefined' || !isHomepagePath()) {
    return null;
  }
  if (bootstrapData) {
    return Promise.resolve(bootstrapData);
  }
  if (bootstrapPromise) {
    return bootstrapPromise;
  }

  bootstrapPromise = axios
    .get(`${BACKEND_URL}/api/public/homepage-bootstrap`)
    .then((response) => {
      applyHomepageBootstrap(response.data);
      return response.data;
    })
    .catch(() => null);

  return bootstrapPromise;
}
